import { Card, ControlMessage, InAppMessage } from '@braze/web-sdk'
import { BrazeAction, BrazeActionType } from './BrazeActions'

export interface BrazeState {
    isBrazeInitialized: boolean;
    canBrazeSchedulerStart: boolean;
    contentCards: Card[];
    inAppMessages: (InAppMessage | ControlMessage)[];
    notificationShownRecently: boolean;
    inboxUpdatedRecently: boolean;
}

export const initialState: BrazeState = {
    isBrazeInitialized: false,
    canBrazeSchedulerStart: false,
    contentCards: [],
    inAppMessages: [],
    notificationShownRecently: false,
    inboxUpdatedRecently: false,
}

export const brazeReducer = (
    state: BrazeState = initialState,
    action: BrazeAction
): BrazeState => {
    switch (action.type) {
        case BrazeActionType.BRAZE_INITIALIZED:
            return {
                ...state,
                isBrazeInitialized: true,
            }
        case BrazeActionType.NOTIFICATION_SCHEDULER_STARTED:
            return {
                ...state,
                canBrazeSchedulerStart: true,
            }
        case BrazeActionType.CONTENT_CARDS_UPDATED:
            return {
                ...state,
							  contentCards: action.payload
            }
        case BrazeActionType.IN_APP_MESSAGE_RECEIVED:
            return {
                ...state,
                inAppMessages: [ ...state.inAppMessages, action.payload ]
            }
        case BrazeActionType.IN_APP_MESSAGE_SHOWN:
            const notificationMessage = action.payload
            return {
                ...state,
                inAppMessages: state.inAppMessages.filter((message) => message !== notificationMessage)
            }
        case BrazeActionType.IN_APP_MESSAGE_COOLDOWN_STARTED:
            return {
                ...state,
                notificationShownRecently: true
            }
        case BrazeActionType.IN_APP_MESSAGE_COOLDOWN_COMPLETED:
            return {
                ...state,
                notificationShownRecently: false
            }
        case BrazeActionType.INBOX_UPDATE_COOLDOWN_STARTED:
            return {
                ...state,
                inboxUpdatedRecently: true
            }
        case BrazeActionType.INBOX_UPDATE_COOLDOWN_COMPLETED:
            return {
                ...state,
                inboxUpdatedRecently: false
            }
        default:
            return state
    }
}
